import type { Theme } from '@mui/material';
import Grid from '@mui/material/GridLegacy';
import type { GridSpacing } from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Background } from '../Background';
import { Block } from '../Block';
import type { PageProps } from './Page.types';

const PREFIX = 'Page';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')(({ theme }: { theme: Theme }) => ({
  [`& .${classes.root}`]: {
    color: theme.palette.primary.main,
    overflow: 'hidden',
    paddingTop: theme.spacing(20),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(10),
    },
  },
}));

export const Page: React.FC<PageProps> = ({ page }) => {
  return (
    <Root>
      {page?.backgroundImage && <Background image={page?.backgroundImage} />}
      <div className={classes.root}>
        <Grid container justifyContent="center">
          {page?.outerColumnGapMD &&
            page?.outerColumnGapSM &&
            page?.outerColumnGapXS && (
              <>
                <Grid
                  item
                  xs={page?.outerColumnGapXS}
                  sm={page?.outerColumnGapSM}
                  md={page?.outerColumnGapMD}
                />
                <Grid
                  item
                  xs={12 - 2 * (page?.outerColumnGapXS || 0)}
                  sm={12 - 2 * (page?.outerColumnGapSM || 0)}
                  md={12 - 2 * (page?.outerColumnGapMD || 0)}>
                  <Grid
                    container
                    spacing={page.spacing as GridSpacing}
                    justifyContent="center"
                    style={{ minHeight: '100vh' }}>
                    {page.blocks?.map((block) => {
                      return (
                        block && (
                          <React.Fragment key={block?.documentId}>
                            <Block block={block} />
                          </React.Fragment>
                        )
                      );
                    })}
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={page.outerColumnGapXS}
                  sm={page.outerColumnGapSM}
                  md={page.outerColumnGapMD}
                />
              </>
            )}
        </Grid>
      </div>
    </Root>
  );
};

export default Page;
